var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber, Contract } from 'ethers';
import * as plugins from '../../../Fct/pluginsExport';
import { kiroboMulticallSimulateContracts } from '../KIROBO_MULTICALL_CSV/constants';
import createMulticallPlugin from './generic/createMulticallPlugin';
import erc20Abi from '../../../abis/erc20.json';
export var Erc20MonoTransfers = createMulticallPlugin({
    plugin: plugins.ERC20.actions.SimpleTransfer,
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY',
    method: 'erc20MonoTransfers',
    name: 'erc20MonoTransfers',
    config: {
        params: [
            { key: 'to', multicallKey: 'token', isUnique: true, isPreview: true },
            { key: 'methodParams.from', multicallKey: 'from', isUnique: true, isPreview: true },
            { key: 'methodParams.to', multicallKey: 'to', isPreview: true },
            { key: 'methodParams.amount', multicallKey: 'amount', isPreview: true, },
        ],
        tupleName: 'transfers',
    },
    estimateGasFromPlugins: function (plugins, chainId) {
        // Gas notes:
        // 35k first
        // 28k every next
        var gas = BigNumber.from(35000);
        if (plugins.length > 1) {
            gas = gas.add(BigNumber.from(28000).mul(BigNumber.from(plugins.length - 1)));
        }
        if (chainId === '42161') {
            gas = gas.mul(BigNumber.from(13));
        }
        return gas.toString();
    },
    beforeSimulate: function (_a) {
        var params = _a.params, provider = _a.provider, chainId = _a.chainId;
        return __awaiter(void 0, void 0, void 0, function () {
            var tupleParams, tokenValues, amountToSend, contractAddress, tokenAddress, contract, allowance;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!params)
                            return [2 /*return*/];
                        tupleParams = (_b = params.find(function (param) { return param.type === 'tuple[]'; })) === null || _b === void 0 ? void 0 : _b.value;
                        if (!tupleParams)
                            return [2 /*return*/];
                        console.log({ tupleParams: tupleParams });
                        tokenValues = tupleParams === null || tupleParams === void 0 ? void 0 : tupleParams.map(function (tuple) { return tuple.find(function (t) { return t.name === 'amount'; }); });
                        console.log({ tokenValues: tokenValues });
                        if (!tokenValues)
                            return [2 /*return*/];
                        if (!('length' in tokenValues))
                            return [2 /*return*/];
                        amountToSend = BigNumber.from('0');
                        tokenValues.forEach(function (amount) {
                            if (amount)
                                amountToSend = amountToSend.add(amount.value);
                        });
                        console.log({ amountToSend: amountToSend });
                        contractAddress = kiroboMulticallSimulateContracts[chainId];
                        return [4 /*yield*/, ((_c = provider === null || provider === void 0 ? void 0 : provider.signer) === null || _c === void 0 ? void 0 : _c.sendTransaction({
                                to: contractAddress,
                                value: '1' + '0'.repeat(3),
                            }))];
                    case 1:
                        _d.sent();
                        tokenAddress = params[0].value;
                        console.log({ tokenAddress: tokenAddress });
                        if (!tokenAddress)
                            return [2 /*return*/];
                        contract = new Contract(tokenAddress, erc20Abi, provider === null || provider === void 0 ? void 0 : provider.signer);
                        return [4 /*yield*/, contract['approve'](contractAddress, amountToSend.toString(), {})];
                    case 2:
                        allowance = _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
});
